export default __webpack_public_path__ + "static/media/ATA-BNB.020329ea.svg";